import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconCalendarSharpLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.624 3.999v2.626h6.752V3.999h2v2.626h2.626v13.378H3.998V6.625h2.626V3.999h2ZM18.002 11V8.625H5.998V11h12.004ZM5.998 13v5.003h12.004V13H5.998Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconCalendarSharpLine);
export default Memo;
